


$('.single-slider .slide-list').slick({
  dots: false,
  infinite: true,
  arrows:true, 
  speed: 300,
  slidesToShow: 1,
  adaptiveHeight: true
});

$('.reviews-blocks .reviews-slider-list').slick({
  dots: false,
  infinite: true,
  arrows:true, 
  speed: 300,
  slidesToShow: 1,
  adaptiveHeight: true
});

$('.reviews-sec .reviews-slider').slick({
  dots: false,
  infinite: true,
  arrows:true, 
  speed: 300,
  slidesToShow: 1,
  adaptiveHeight: true
});


$('.customer-section .customer-itam-main').slick({
  dots: false,
  infinite: true,
   loop:true,
  speed: 300,
  slidesToShow: 1,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});





$('.papular-section .papular-itam-main').slick({
  dots: false,
 // infinite: true,
 // loop:true,
  speed: 300,
  slidesToShow: 4,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
       // infinite: false,
        dots: false
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});






$('.popsurf-section .popsurf-slide-main').slick({
  dots: false,
  infinite: true,
   loop:true,
  speed: 300,
  slidesToShow: 3,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});

 let items = document.querySelector(".header__inline-menu").querySelectorAll("details");
  console.log(items)
  items.forEach(item => {
    item.addEventListener("mouseover", () => {
      item.setAttribute("open", true);
      item.querySelector("ul").addEventListener("mouseleave", () => {
        item.removeAttribute("open");
      });
    item.addEventListener("mouseleave", () => {
      item.removeAttribute("open");
    });
  });
  
  });






$('.popularityproducts-banner-slider .popularityproducts-itam-main').slick({
  dots: false,
  infinite: true,
  arrows:true, 
  speed: 300,
  slidesToShow: 1,
  adaptiveHeight: true
});





$('.popularityproducts-itam-main1').slick({
  dots: false,
  infinite: true,
  arrows:true, 
  speed: 300,
  slidesToShow: 1,
  adaptiveHeight: true
});





